module.exports = __webpack_public_path__ + "img/income.155fb71d.svg";